import React, { useEffect, useState } from 'react'
import styles from './index.module.less'
import { useTranslation } from 'react-i18next'
import { ModuleTransfer } from '@/api/blocks/interface'
import AddressHash from '@/components/AddressHash'
import { ugagToGag, ugeaToGea2 } from '@/utils/number'
import useMeNavigate from '@/hooks/useMeNavigate'
import { getTransactionType } from '@/views/Transaction/utils'
import { BlockChainTypeEnums } from '@/enums'
import classNames from 'classnames'
const ModuleAccountTransition = ({ moduleTransfer }: { moduleTransfer: ModuleTransfer }) => {
  const navigate = useMeNavigate()
  const [amountGag, setAmountGag] = useState<{
    value: string
    sigin: string
  }>({
    value: '-',
    sigin: '',
  })
  const [amountGea, setAmountGea] = useState<{
    value: string
    sigin: string
  }>({
    value: '-',
    sigin: '',
  })

  const types = getTransactionType('ModuleAddressType')

  const getGag = () => {
    if (!moduleTransfer.amount) return
    const str = moduleTransfer.amount.split(',')
    str.forEach((item) => {
      if (item.includes('ugag')) {
        setAmountGag(ugagToGag(item))
      } else {
        setAmountGea(ugeaToGea2(item))
      }
    })
  }
  useEffect(() => {
    getGag()
  }, [])

  const getTag = (tag: string) => {
    if (!tag) return '-'
    let key = ''
    const item = types.pageKeyList.find((item) => {
      let newKey: string = item.key
      if (newKey.endsWith('%s')) {
        newKey = newKey.replace('%s', '')
        key = newKey
      }
      if (tag?.startsWith(newKey)) {
        return true
      }
      key = newKey
      return item.key === tag
    })
    let region = tag.slice(key.length)
    if (region && region.length) {
      if (region.toLowerCase() === 'global_village') {
        region = t('explorer_266')
      } else {
        region = region.toUpperCase()
      }
      if (item?.label?.endsWith('(%s)')) {
        return item.label.replace('(%s)', `(${region})`)
      }
    }
    if (item) {
      return item.label
    }
    return '-'
  }

  const { t } = useTranslation()
  return (
    <div>
      <div className={styles.wrap}>
        <div>
          {/* 类型 */}
          <div className={styles.title}>{t('explorer_104')}</div>
          <div className={classNames(styles.textStyleTwo, 'font_14')}>
            {getTag(moduleTransfer.tag)}
          </div>
        </div>
        <div>
          {/* 从 */}
          <div className={styles.title}>{t('explorer_106')}</div>
          <div className={classNames(styles.textStyleOne, 'font_14')}>
            {BlockChainTypeEnums[
              moduleTransfer.from_address as unknown as keyof typeof BlockChainTypeEnums
            ] ? (
              t(
                BlockChainTypeEnums[
                  moduleTransfer.from_address as unknown as keyof typeof BlockChainTypeEnums
                ],
              )
            ) : (
              <AddressHash
                data={moduleTransfer.from_address}
                cutOption
                // gea开头的才能跳转
                handleJump={() => {
                  if (moduleTransfer.from_address.startsWith('gea')) {
                    navigate(`/accountDetail/${moduleTransfer.from_address}`)
                  }
                }}
              ></AddressHash>
            )}
          </div>
        </div>
        {/* <div className={styles.toIcon}><span className={styles.to}></span></div> */}
        <div>
          {/* 到 */}
          <div className={styles.title}>{t('explorer_107')}</div>
          <div className={classNames(styles.textStyleOne, 'font_14')}>
            <AddressHash
              data={moduleTransfer.to_address}
              cutOption
              handleJump={() => {
                if (moduleTransfer.to_address.startsWith('gea')) {
                  navigate(`/accountDetail/${moduleTransfer.to_address}`)
                }
              }}
            ></AddressHash>
          </div>
        </div>
        <div>
          {/* 数量 */}
          <div className={styles.title}>{t('explorer_105')}</div>
          <div
            style={{ marginBottom: '2px' }}
            className={classNames(styles.textStyleTwo, 'font_14')}
          >
            <span>{amountGea.value}</span>{' '}
            <span className={classNames(styles.textStyleThree, 'font_14')}>{amountGea.sigin}</span>
          </div>
          {amountGag.sigin ? (
            <>
              <div className={classNames(styles.textStyleTwo, 'font_14')}>
                <span>{amountGag.value}</span>{' '}
                <span className={classNames(styles.textStyleThree, 'font_14')}>
                  {amountGag.sigin}
                </span>
              </div>
            </>
          ) : null}
        </div>
      </div>
      <div className={styles.mobilewrap}>
        <div className="mobilewrap_top">
          <div>
            {/* 类型 */}
            <div className={styles.title}>{t('explorer_104')}</div>
            <div className={classNames(styles.textStyleTwo, 'font_14')}>
              {getTag(moduleTransfer.tag)}
            </div>
          </div>
          <div>
            {/* 从 */}
            <div className={styles.title}>{t('explorer_106')}</div>
            <div className={classNames(styles.textStyleOne, 'font_14')}>
              {BlockChainTypeEnums[
                moduleTransfer.from_address as unknown as keyof typeof BlockChainTypeEnums
              ] ? (
                t(
                  BlockChainTypeEnums[
                    moduleTransfer.from_address as unknown as keyof typeof BlockChainTypeEnums
                  ],
                )
              ) : (
                <AddressHash
                  data={moduleTransfer.from_address}
                  cutOption
                  handleJump={() => {
                    if (moduleTransfer.from_address.startsWith('gea')) {
                      navigate(`/accountDetail/${moduleTransfer.from_address}`)
                    }
                  }}
                ></AddressHash>
              )}
            </div>
          </div>
        </div>
        <div className="mobilewrap_center">
          <div className={styles.toIcon}>{/* <span className={styles.to}></span> */}</div>
        </div>
        <div className="mobilewrap_bottom">
          <div>
            {/* 数量 */}
            <div className={styles.title}>{t('explorer_105')}</div>
            <div className={classNames(styles.textStyleTwo, 'font_14')}>
              <span>{amountGea.value}</span>{' '}
              <span className={classNames(styles.textStyleThree, 'font_14')}>
                {amountGea.sigin}
              </span>
            </div>
            {amountGag.sigin ? (
              <div className={styles.textStyleTwo}>
                <span className={classNames('font_14')}>{amountGag.value}</span>{' '}
                <span className={classNames(styles.textStyleThree, 'font_14')}>
                  {amountGag.sigin}
                </span>
              </div>
            ) : null}
          </div>
          <div>
            {/* 到 */}
            <div className={styles.title}>{t('explorer_107')}</div>
            <div className={classNames(styles.textStyleOne, 'font_14')}>
              <AddressHash
                data={moduleTransfer.to_address}
                cutOption
                handleJump={() => {
                  if (moduleTransfer.to_address.startsWith('gea')) {
                    navigate(`/accountDetail/${moduleTransfer.to_address}`)
                  }
                }}
              ></AddressHash>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModuleAccountTransition
